export const customerProductQuery = () => {
  const query = `*[_type == "customerProduct"]{
    ...,
    "supplierProducts" :supplierProducts[]->, 
    "law": law->  
  }`;
  return query;
};

export const productQuery = () => {
  const query = `*[_type == "product"]`;
  return query;
};
export const clientOrdersQuery = (offerId) => {
  const query = `*[_type == "clientOrder" && offerId == '${offerId}']`;
  return query;
};
export const clientOrdersArrayQueryByOfferIds = (offerIds) => {
  const query = `*[_type == "clientOrder" && offerId in [${offerIds}]] | order(_createdAt desc)`;
  return query;
};
export const clientOrdersByClient = (clientId) => {
  const query = `*[_type == "clientOrder" && client._ref == "${clientId}" ] | order(_createdAt desc)`;
  return query;
};
export const pdfQuery = (categoryId) => {
  const query = `*[_type == "pdf" && references("${categoryId}")]{..., "url": file.asset->url}`;
  return query;
};

export const customerProductsOfNonConformityQuery = (nonConformityId) => {
  const query = `*[_type == "customerProduct" && "${nonConformityId}" in nonConformities[]._ref]{
    ...,
    "supplierProducts" :supplierProducts[]->, 
    "law": law->  
  }`;
  return query;
};

export const siteRegistersReport = (siteId) => {
  //console.log("siteId in siteRegistersReport query", siteId)
  const query =
  `*[_type == "register" && site._ref == '${siteId}']{
    "nDevices":count(devices)}`
  return query
}
export const chargeQuery = () => {
  const query = 
  `
  *[_type == "customer"]{
     name,
    "clients": *[_type=='client' &&  references(^._id)]{
       "sites": *[_type=='site' &&  references(^._id)]{
          "registers": *[_type=='register' &&  references(^._id)]{
             "nDevices":count(devices),
       },
          "nRegisters" : count( *[_type=='register' &&  references(^._id)])
       },
       "nSites": count( *[_type=='site' &&  references(^._id)])
  },
    "nClients": count( *[_type=='client' &&  references(^._id)])
  }

  `
  return query
}

export const customersQuery = () => {
  const query = `*[_type == "customer"]`;
  return query;
};

export const fetchPdf = async () => {
  const query = `*[_type == "pdf"]`;
  return query;
};

export const singleListQuery = (listId) => {
  const query = `*[_type == "list" && _id == "${listId}"][0]{...,fieldList[]->}`;
  return query;
}

export const templatesQuery = (customerTemplateIds) => { 
  const query = `*[_type == "registerTemplates" && _id in [${customerTemplateIds}] ]{
    ...,   
    "devices":devices[]->, 
    "deadlineType":deadlineType->,
    "locations":locations[]->{...,"lists":lists[]->{...,fieldList[]->}}, 
    "fields":fields[]->
      {...,
      "nonConformities":nonConformities[]->,
      "lists":lists[]->{...,fieldList[]->},
      "maxNonConformity":maxNonConformity->,
      "minNonConformity":minNonConformity->,
      "zeroNonConformity":zeroNonConformity->
      },
    "dates":dates[]->
      {...,
      "nonConformities":nonConformities[]->,
      "lists":lists[]->{...,fieldList[]->}
    
      },
    "registerFields":registerFields[]->,
    "nonConformities": nonConformities[]->
   }`; 
  return query;
};
export const clientsQueryIndex = (customerId, assignedClients, sUser) => {
  const query = () => {
    if(!sUser) return []
    if(sUser.userType == "Cliente") {

        if(sUser?.assignedClients?.length < 1) {
            //console.log("Cliente null")
            return []
        }
        else {
                return `*[_type == "client" && status !="ARCHIVIATO" && _id in [${assignedClients}]]`
              }
    }
    if(assignedClients?.length>0){return `*[_type == "client" && status !="ARCHIVIATO" && _id in [${assignedClients}]]`}
    return  `*[_type == "client" && status !="ARCHIVIATO" && (customer._ref == '${customerId}' || "${customerId}" in contractors[]._ref)]`;
    
  }
  return query();
};
export const clientsQuery = (customerId, assignedClients) => {
  const query = () => {
    if(assignedClients?.length>0){return `*[_type == "client" && status !="ARCHIVIATO" && _id in [${assignedClients}]]`}
    return  `*[_type == "client" && status !="ARCHIVIATO" && (customer._ref == '${customerId}' || "${customerId}" in contractors[]._ref)]`;
    
  }
  return query();
};
export const nonConfQuery = (customerTemplateIds) => {
  //const query = `*[_type == "nonConformity" && substitution != true && supply != true]`;
  const query = `*[_type == "nonConformity" && substitution != true && supply != true && count((registers[]._ref)[@ in [${customerTemplateIds}]]) > 0 ]`; 
  return query;
};
export const subNonConformities = (customerTemplateIds) => {
  //const query = `*[_type == "nonConformity" && substitution != true && supply != true]`;
  const query = `*[_type == "nonConformity" && (substitution == true || supply == true)]`; 
  return query;
};
export const customerUsersQuery = (customerId) => {
  const query = `*[_type == "user" && customer._ref == '${customerId}']`;
  return query;
};
export const contractorsUsersQuery = (contractorIds) => {
  const query = `*[_type == "user" && userType == "Tecnico" && customer._ref in [${contractorIds}]]`;
  return query;
};

/* export const nonConfQuery = (registerId) => {
  const query = `*[_type == "nonConformity" && "${registerId}" in registers[]._ref]`;
  return query;
}; */

export const sitesQuery = (clientId) => {
  const query = `*[_type == "site" && status != "ARCHIVIATO" && client._ref == '${clientId}']`;
  return query;
};
export const allSitesStatusesQuery = (clientId) => {
  const query = `*[_type == "site" && client._ref == '${clientId}']`;
  return query;
};
export const clientsSitesQuery = (clientIds) => {
  const query = `*[_type == "site" && status != "ARCHIVIATO" && client._ref in [${clientIds}]]`;
  return query;
};
export const registersQuery = (siteId, status) => {
  const statusQuery = `*[_type == "register" && site._ref == '${siteId}' && status == '${status}']`
  const query = `*[_type == "register" && site._ref == '${siteId}']`
  return status ? statusQuery : query; 
};
export const todayRegistersQuery = (days=1) => {
  
  const query = `*[_type == "register" && dateTime(_updatedAt) > dateTime(now()) - 60*60*24*${days}]`;
  return query; 
};
export const sitesQueryByIds = (sitesIdsArray) => {
  const query =`*[_type== "site" && _id in [${sitesIdsArray}]]`

  return query;
}
export const clientsQueryByIds = (clientsIdsArray) => {
  const query =`*[_type== "client" && _id in [${clientsIdsArray}]]`

  return query;
}

export const substituteReasonsQuery = () => {

  const query = `*[_type == "list" && _id == "5fabe5aa-8b2b-4bb8-b232-c51ba64fa221"][0]{
      "fieldList":fieldList[]-> 
  }`; 
  return query;
};

export const severeNonConformitiesQuery = () => {

  const query = `*[_type == "nonConformity" && notification]`; 
  return query;
};
 

export const emailTemplatesQuery = (customerId) => {
  const query = `*[_type == "emailTemplate" && customer._ref == '${customerId}']`;
  return query;
};
export const registerIdsQuery = (siteId, status) => {
  const statusQuery = `*[_type == "register" && site._ref == '${siteId}' && status == '${status}']{ "_id":_id}`
  const query = `*[_type == "register" && site._ref == '${siteId}']{ "_id":_id}`;
  return status ? statusQuery : query; 
};
export const deviceNonConformitiesQuery = (siteId) => {
  const query = `*[_type == "deviceNonConformity" && site._ref == '${siteId}']`;
  return query; 
};
export const priceListQuery = (clientId) => {
  const query = `*[_type == "priceList" && ('${clientId}' in clients[].client._ref || !defined(client))]`;
  return query; 
};
export const allPriceListQuery = () => {
  const query = `*[_type == "priceList"]`;
  return query; 
};



/*
export const registersQuery = (siteId) => {
  const query = `*[_type == "register" && site._ref == '${siteId}']{
    ...,   
    "devices":devices[]->{
      ...,
      "fields":fields[] {
             ...,
             "templateField":templateField->
            
            }, 
      "locations":locations[] {
        ...,
        "templateField":templateField->
        
        }
    }, 
   }`;
  return query; 
};



export const devicesQuery = (registerId) => {
  const query =`*[_type== "device" && register._ref == '${registerId}']{
    ...,
      "fields":fields[] {
             ...,
             "templateField":templateField->
            
            }, 
      "locations":locations[] {
        ...,
        "templateField":templateField->
        
        }

  }`

  return query;
}

*/
export const devicesQuery = (siteId) => {
  const query =`*[_type== "device" && site._ref == '${siteId}']{
    ...,
    "userLog":userLog[]{
      ...,
      "postedBy":postedBy->{
        "firstName":firstName,
        "lastName":lastName,
        "image":image,
      }
    }

  }`

  return query;
}

export const offersQuery = (sitesIdsArray) => {
  const query =`*[_type== "offer" && status == "ATTIVO" && site._ref in [${sitesIdsArray}]]`

  return query;
}

export const clientDevicesQuery = (sitesIdsArray) => {
  const query =`*[_type== "device" && status == "ATTIVO" && site._ref in [${sitesIdsArray}]]{
    ...,
    "userLog":userLog[]{
      ...,
      "postedBy":postedBy->{
        "firstName":firstName,
        "lastName":lastName,
        "image":image,
      }
    }

  }`

  return query;
}

export const clientOffersSiteIds = (clientId, clientOfferId) => {
  const query =`*[
    _type== "offer" && 
    status == "ATTIVO" && 
    client._ref == '${clientId}' &&
    count(offerFields[clientOrder._ref == "${clientOfferId}" && labourProduct != "true"]) > 0
    ]{
      "siteId": site._ref
  }`

  return query;
}

export const offersIndexQuery = (siteId) => {
  const query =`*[
    _type== "offer" && 
    status == "ATTIVO" && 
    site._ref == '${siteId}' &&
    count(offerFields[defined(clientOrder)]) > 0
    ]{
      ...,
      offerFields[]{
      ...,
      customerProduct,
      deviceNonConformityId,
      clientOrder,
      deviceId,
      nonConformityId,
      nonConformity,
      registerId,
      siteId,
      _id,
      }[defined(clientOrder)],
      offerId,
      _id
  }`

  return query;
}
export const allClientOffers = (clientId) => {
  const query =`*[
    _type== "offer" && 
    status == "ATTIVO" && 
    client._ref == '${clientId}' &&
    count(offerFields[defined(clientOrder)]) > 0
    ]{
      ...,
      offerFields[]{
      ...,
      customerProduct,
      deviceNonConformityId,
      clientOrder,
      deviceId,
      nonConformityId,
      nonConformity,
      registerId,
      siteId,
      _id,
      }[defined(clientOrder)],
      offerId,
      _id
  }`

  return query;
}
export const registerDevicesQuery = (registersIdsArray) => {
  const query =`*[_type== "device" && status == "ATTIVO" && register._ref in [${registersIdsArray}]]{
    ...,
    "userLog":userLog[]{
      ...,
      "postedBy":postedBy->{
        "firstName":firstName,
        "lastName":lastName,
        "image":image,
      }
    }

  }`

  return query;
}

export const clientRegistersQuery = (sitesIdsArray, status) => {
  const query = `*[_type == "register" && status == "ATTIVO" && site._ref in [${sitesIdsArray}]]`;
  const statusQuery = `*[_type == "register" && status == '${status}' && site._ref in [${sitesIdsArray}]]`
  
  return status ? statusQuery : query; 
  
};
export const clientArchivedRegistersQuery = (sitesIdsArray, status) => {
  const query = `*[_type == "register" && status == "ARCHIVIATO" && site._ref in [${sitesIdsArray}]]`;
  const statusQuery = `*[_type == "register" && status == '${status}' && site._ref in [${sitesIdsArray}]]`
  
  return status ? statusQuery : query; 
  
};
export const registersOfTemplateQuery = (templateId) => {
  const query = `*[_type == "register" && status == "ATTIVO" && template._ref == '${templateId}']`;

  
  return query
  
};

//count(*[_type == "deviceNonConformity" && status == "DA FARE" && site._ref == ^.site._ref ])

export const clientNonConformitiesQuery = (sitesIdsArray) => {
  const query = `*[_type == "deviceNonConformity" && status == "DA FARE" && site._ref in [${sitesIdsArray}]]`;
  return query; 
};



export const fromidsNonConformitiesQuery = (devicesIdsArray) => {
  const query = `*[_type == "deviceNonConformity" && device._ref in [${devicesIdsArray}]]`;
  return query; 
};


export const singleFieldQuery = (fieldId) => {
  const query = `*[_type == "dataModule" && _id == '${fieldId}']`
  return query;
};
export const dateFieldsQuery = () => {
  const query = `*[_type == "dataModule" && defined(dateType)]`
  return query;
};


export const fieldsQuery = (fieldId) => {
  const query1 = `*[_type == "dataModule" && dataModule._id == '${fieldId}']`;
  const query = `*[_type == "dataModule" && _id == '${fieldId}']`
  return query;
};

export const userQuery = (userId) => {
    const query = `*[_type == "user" && _id == '${userId}']`;
    return query;
};
export const emailQuery = (email) => {
  const query = `*[_type == "user" && email == '${email}']`;
  return query;
};

export const searchQuery = (searchTerm) => {
    const query = `*[_type == "pin" && title match '${searchTerm}*' || category match '${searchTerm}*' || about match '${searchTerm}*']{
          image{
            asset->{
              url
            }
          },
              _id,
              destination,
              postedBy->{
                _id,
                userName,
                image
              },
              save[]{
                _key,
                postedBy->{
                  _id,
                  userName,
                  image
                },
              },
            }`;
    return query;
};

export const feedQuery = `*[_type == "pin"] | order(_createdAt desc) {
  image{
    asset->{ 
      url
    }
  },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    } `;


    export const categories = [
      {
        name: 'Estintori',
        image: 'https://i.pinimg.com/750x/eb/47/44/eb4744eaa3b3ccd89749fa3470e2b0de.jpg',
      },
      {
        name: 'Idranti',
        image: 'https://i.pinimg.com/236x/25/14/29/251429345940a47490cc3d47dfe0a8eb.jpg',
      },
      {
        name: 'Porte',
        image: 'https://i.pinimg.com/236x/03/48/b6/0348b65919fcbe1e4f559dc4feb0ee13.jpg',
      },
      {
        name: 'Uscite',
        image: 'https://i.pinimg.com/750x/66/b1/29/66b1296d36598122e6a4c5452b5a7149.jpg',
      },
      {
        name: 'photo',
        image: 'https://i.pinimg.com/236x/72/8c/b4/728cb43f48ca762a75da645c121e5c57.jpg',
      },
      {
        name: 'food',
        image: 'https://i.pinimg.com/236x/7d/ef/15/7def15ac734837346dac01fad598fc87.jpg',
      },
      {
        name: 'nature',
        image: 'https://i.pinimg.com/236x/b9/82/d4/b982d49a1edd984c4faef745fd1f8479.jpg',
      },
      {
        name: 'art',
        image: 'https://i.pinimg.com/736x/f4/e5/ba/f4e5ba22311039662dd253be33bf5f0e.jpg',
      }, {
        name: 'travel',
        image: 'https://i.pinimg.com/236x/fa/95/98/fa95986f2c408098531ca7cc78aee3a4.jpg',
      },
      {
        name: 'quotes',
        image: 'https://i.pinimg.com/236x/46/7c/17/467c17277badb00b638f8ec4da89a358.jpg',
      }, {
        name: 'cats',
        image: 'https://i.pinimg.com/236x/6c/3c/52/6c3c529e8dadc7cffc4fddedd4caabe1.jpg',
      }, {
        name: 'dogs',
        image: 'https://i.pinimg.com/236x/1b/c8/30/1bc83077e363db1a394bf6a64b071e9f.jpg',
      },
      {
        name: 'others',
        image: 'https://i.pinimg.com/236x/2e/63/c8/2e63c82dfd49aca8dccf9de3f57e8588.jpg',
      },
    ];


export const pinDetailQuery = (pinId) => {
  const query = `*[_type == "pin" && _id == '${pinId}']{
    image{
      asset->{
        url
      }
    },
    _id,
    title,
    about,
    category,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
   save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
    comments[]{
      comment,
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    }
  }`;
  return query;
};

export const pinDetailMorePinQuery = (pin) => {
  const query = `*[_type == "pin" && category == '${pin.category}' && _id != '${pin._id}' ]{
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};




export const userCreatedPinsQuery = (userId) => {
  const query = `*[ _type == 'pin' && userId == '${userId}'] | order(_createdAt desc){
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};

export const userSavedPinsQuery = (userId) => {
  const query = `*[_type == 'pin' && '${userId}' in save[].userId ] | order(_createdAt desc) {
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};
